import {Loader} from '@googlemaps/js-api-loader';
import Swiper from "swiper";

window.addEventListener("DOMContentLoaded", (event) => {
	initSwiper();
	initMap();
});

const initSwiper = () => {
	const FacilitySwiper = new Swiper('.swiper-container-gallery', {
		effect: 'fade',
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		speed: 500,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		watchSlidesProgress: true,
		thumbs: {
			swiper: {
				el: '.swiper-container-thumbs',
				allowTouchMove: false,
				//direction: 'vertical',
				slidesPerView: 3,
				breakpoints: {
					//768: {
					//	slidesPerView: 3,
					//	slidesPerGroup: 3,
					//},
					980: {
						slidesPerView: 4,
						slidesPerGroup: 2,
					},
					1200: {
						slidesPerView: 6,
						slidesPerGroup: 1,
					}
				},
				//scrollbar: {
				//el: ".swiper-scrollbar",
				//	hide: false,
				//},
			}
		},
		ally: false
	});
	//stop-btn
	$('.stopbtn').on('click', function () {
		if ($(this).attr('class') === 'stopbtn stop') {
			$(this)
				.addClass('start')
				.removeClass('stop');
			FacilitySwiper.autoplay.stop();
		} else {
			$(this)
				.addClass('stop')
				.removeClass('start');
			FacilitySwiper.autoplay.start();
		}
	}).keypress(function (e) {
		let keycode = event.keyCode ? event.keyCode : event.which;
		if (13 == keycode) {
			$(this).click();
		}
	});
}

const initMap = () => {
	const mapEl = $('#facility-map');
	if (mapEl.length > 0 && mapEl.find('.marker').length > 0) {
		const markerEl = mapEl.find('.marker')[0];
		const lat = $(markerEl).data('lat');
		const lng = $(markerEl).data('lng');
		const latLng = {
			lat: parseFloat(lat),
			lng: parseFloat(lng)
		};

		const loader = new Loader({
			apiKey: "AIzaSyAojWj_yiczxcLBOrs1SKzsUt-LwFl3bjE",
			version: "quarterly",
			region: 'JP',
			language: 'en'
		});

		const mapOptions = {
			center: {
				lat: lat,
				lng: lng
			},
			zoom: mapEl.data('zoom') || 14
		};

		loader
			.load()
			.then((google) => {
				const gmap = new google.maps.Map(document.getElementById("facility-map"), mapOptions);
				const marker = new google.maps.Marker({
					position: latLng,
					map: gmap
				});
			})
			.catch(e => {
				console.log('failed to load gmap');
			});
	}
}

